import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { alertsAPI } from "components/Apis/alerts";

export const fetchActiveAlerts = createAsyncThunk(
    'alerts/fetchActiveAlerts',
    async ({ params = {}, append = false } = {}, { rejectWithValue }) => {
        try {
            const response = await alertsAPI.fetchAlerts(params);
            return { data: response.data, append };
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
)

const normalizeAlertsPayload = (payload) => {
    if (!payload) {
        return { results: [], count: 0, next: null, previous: null };
    }
    if (Array.isArray(payload)) {
        return { results: payload, count: payload.length, next: null, previous: null };
    }
    if (Array.isArray(payload.results)) {
        return {
            results: payload.results,
            count: payload.count ?? payload.results.length,
            next: payload.next ?? null,
            previous: payload.previous ?? null,
        };
    }
    return { results: [], count: 0, next: null, previous: null };
};

const alertsSlice = createSlice({
    name: 'alerts',
    initialState: {
        activeAlerts: {
            options: {
                messageChoices: [],
                filters: null,
            },
            alertsList: [],
            count: 0,
            next: null,
            previous: null,
            selectedAlert: null,
            loading: false,
            error: null,
        },
    },
    reducers: {
        setOptions: (state, action) => {
            state.activeAlerts.options = action.payload;
        },
        setAlertsList: (state, action) => {
            state.activeAlerts.alertsList = action.payload;
        },
        setSelectedAlert: (state, action) => {
            state.activeAlerts.selectedAlert = action.payload;
        },
        setLoading: (state, action) => {
            state.activeAlerts.loading = action.payload;
        },
        setError: (state, action) => {
            state.activeAlerts.error = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchActiveAlerts.pending, (state) => {
                state.activeAlerts.loading = true;
                state.activeAlerts.error = null;
            })
            .addCase(fetchActiveAlerts.fulfilled, (state, action) => {
                const { data, append } = action.payload || {};
                const normalized = normalizeAlertsPayload(data);
                state.activeAlerts.loading = false;
                state.activeAlerts.count = normalized.count;
                state.activeAlerts.next = normalized.next;
                state.activeAlerts.previous = normalized.previous;
                state.activeAlerts.alertsList = append
                    ? state.activeAlerts.alertsList.concat(normalized.results)
                    : normalized.results;
            })
            .addCase(fetchActiveAlerts.rejected, (state, action) => {
                state.activeAlerts.loading = false;
                state.activeAlerts.error = action.payload || "Failed to load alerts.";
            })
    },
});

export const { setOptions, setAlertsList, setSelectedAlert, setLoading, setError } = alertsSlice.actions;
export default alertsSlice.reducer;
